import { render } from "./ShopHeader.vue?vue&type=template&id=7275e655&scoped=true"
import script from "./ShopHeader.vue?vue&type=script&lang=js"
export * from "./ShopHeader.vue?vue&type=script&lang=js"

import "./ShopHeader.vue?vue&type=style&index=0&id=7275e655&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7275e655"]])

export default __exports__